// Production Environment - ng build --configuration production
// Dev Environment - ng build
export const environment = {
  production: false,
  environment: 'dev',
  baseUrl: 'https://main.dev.tapgo.ch/app/v1', // For Local Database
  tenantApi: 'https://tenant.dev.tapgo.ch/app/v1/',
  S3_URL: 'https://demo-tap-go.sos-ch-dk-2.exoscale-cdn.com/',
  END_POINTS: 'https://sos-ch-dk-2.exo.io',
  SPACE_NAME: 'demo-tap-go',
  simulated: 1,
  openReplayProjectKey: 'NpJbXtybXtNaA2URwXnD',
  openReplayIngestPoint: 'https://api.openreplay.com/ingest',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
